module.exports = require("core-js/library/fn/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/get-own-property-descriptors.js
// module id = rXUV
// module chunks = 0